module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"target":"目標達成率","achieved":"実績","remaining":"残り","unit":"円"}}')
  delete Component.options._Ctor
}
